var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "titleOptions" }, [
      _vm.maxChoices == -1
        ? _c("span", [_vm._v(" Choisissez vos " + _vm._s(_vm.title) + " ")])
        : _vm._e(),
      _vm._v(" "),
      _vm.maxChoices == 1
        ? _c("span", [_vm._v(" Choisissez votre " + _vm._s(_vm.title) + " ")])
        : _vm._e(),
      _vm._v(" "),
      _vm.maxChoices > 1 && _vm.minChoices == _vm.maxChoices
        ? _c("span", [
            _vm._v("\n\t\t\tChoisissez vos\n\t\t\t"),
            !_vm.startsWithNumber(_vm.title)
              ? _c("span", [_vm._v(_vm._s(_vm.maxChoices))])
              : _vm._e(),
            _vm._v("\n\t\t\t" + _vm._s(_vm.pluralize(_vm.title)) + "\n\t\t"),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.maxChoices > 1 && _vm.minChoices != _vm.maxChoices
        ? _c("span", [
            _vm.minChoices == 0
              ? _c("span", [
                  _vm._v(
                    "Choisissez jusqu'à " +
                      _vm._s(_vm.maxChoices) +
                      " " +
                      _vm._s(_vm.pluralize(_vm.title))
                  ),
                ])
              : _c("span", [
                  _vm._v(
                    "Choisissez " +
                      _vm._s(_vm.minChoices) +
                      " à " +
                      _vm._s(_vm.maxChoices) +
                      " " +
                      _vm._s(_vm.pluralize(_vm.title))
                  ),
                ]),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.minChoices == null || _vm.minChoices == 0 || _vm.minChoices == -1
      ? _c(
          "div",
          { staticClass: "skipMe radius-18 mx-20 mb-20 shadow-2 no-overflow" },
          [
            _c(
              "div",
              {
                ref: "button",
                staticClass:
                  "btn d-flex justify-content-between align-items-center gap-8",
                attrs: { type: "button", "data-toggle": "button" },
                on: {
                  click: function ($event) {
                    return _vm.toggleChoice()
                  },
                },
              },
              [_vm._m(0), _vm._v(" "), _vm._m(1)]
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("span", { staticClass: "align-item-center d-flex gap-8 m-20" }, [
        _c("i", { staticClass: "icon-eatselfapp_ok-bar m-0" }),
        _c("span", { staticClass: "align-content-center" }, [
          _vm._v("Non, merci"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [_c("i", { staticClass: "plusOk" }, [_vm._v("+")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }